import { publicRequest } from "../../requestMethods";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Loading from "../../components/loading/loading";
import "../../global.css";
import { userRequest } from "../../requestMethods";
import Switch from "@mui/material/Switch";
import CustomGrid from "../../components/grid/CustomGrid";
import RowInput from "../../components/grid/RowInput";

export default function BotList() {
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [companies, setCompanies] = useState();
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);

  useEffect(() => {
    getBots();
    getCompanies();
  }, []);

  const getBots = async () => {
    try {
      setIsLoading(true);
      const res = await userRequest.get(`standard/bots`);
      setData(res.data);
    } catch (error) {
      console.error(error.code);
    }
    setIsLoading(false);
  };

  const deleteBot = async (number, status) => {
    const res = await userRequest.put(`standard/bots/${number}`, {
      enabled: status,
    });

    if (res.data > 0) {
      getBots();
    } else {
      Swal.fire("Atenção!", "Erro ao inativar bot!", "error");
    }
  };

  const getCompanies = async () => {
    const res = await publicRequest.get(`/company`);
    setCompanies(res.data);
  };

  const getUsers = async (companyId) => {
    try {
      const res = await userRequest.get(`${companyId}/users`);
      setUsers(res.data);
    } catch (error) {
      console.error(error.code);
    }
  };

  const handleChangeCompany = (e) => {
    const companyId = e.target.value;
    setSelectedCompanyId(companyId);
    getUsers(companyId);
  };

  const onButtonDeleteClick = (e, row) => {
    if (!e.target.checked) {
      Swal.fire({
        title: "Tem certeza que deseja inativar?",
        text: "Você não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#EE8253",
        confirmButtonText: "Sim, inativar!",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          deleteBot(row, false);
        } else {
          getBots();
        }
      });
    } else {
      deleteBot(row, true);
    }
  };

  const updateAuthBot = async (userId, newValue) => {
    if (!selectedCompanyId) {
      Swal.fire("Atenção!", "Favor selecionar a empresa!", "warning");
      return;
    }
    const res = await userRequest.put(
      `${selectedCompanyId}/users/${userId}`,
      { authorizationBot: newValue === "" ? null : newValue.trim() }
    );
    if (Object.keys(res.data).length > 0) {
      Swal.fire("Parabéns!", "Webhook alterado com sucesso!", "success");
    } else {
      Swal.fire("Erro!", "Erro ao atualizar Webhook!", "error");
    }
  };

  const columns = [
    {
      field: "number",
      headerName: "Número",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "enabled",
      headerName: "",
      width: 80,
      align: "center",
      headerClassName: "dataGridMuiHeader",
      headerAlign: "center",
      display: "flex",
      renderCell: (params) => (
        <Switch
          defaultChecked={params.row.enabled}
          onChange={(e) => onButtonDeleteClick(e, params.row.number)}
        />
      ),
    },
  ];

  const columnsUser = [
    {
      field: "userId",
      headerName: "Cod. Usuário",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "name",
      headerName: "Nome",
      width: 200,
      align: "left",
      headerAlign: "left",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "contact",
      headerName: "Contato",
      width: 150,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
    },
    {
      field: "authorizationBot",
      headerName: "Webhook",
      width: 300,
      align: "center",
      headerAlign: "center",
      headerClassName: "dataGridMuiHeader",
      renderCell: ({ row }) => (
        <RowInput
          value={row.authorizationBot}
          rowId={row.userId}
          onBlur={(id, newValue) => updateAuthBot(id, newValue)}
          width="280px"
        />
      ),
    },
  ];

  return (
    <div className="div_custom_">
      {isLoading ? (
        <Loading />
      ) : (
        <div className="div_custom_UpdateList">
          <div className="div_custom_UpdateItem">
            <CustomGrid
              gridId="botList"
              getRowId={(row) => row.number}
              rows={data}
              columns={columns}
              tableHeight="400px"
            />
          </div>
          <div className="div_custom_UpdateItem">
            <label>Empresas</label>
            <select
              className="div_custom_Select"
              name="company"
              onChange={handleChangeCompany}
            >
              <option value=""></option>
              {companies
                ? companies.map((item) => (
                    <option key={item.companyId} value={item.companyId}>{item.name}</option>
                  ))
                : false}
            </select>
          </div>
          <div className="div_custom_UpdateItem">
            <CustomGrid
              gridId="botUsers"
              getRowId={(row) => row.userId}
              rows={users}
              columns={columnsUser}
              tableHeight="300px"
            />
          </div>
        </div>
      )}
    </div>
  );
}
